"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _List = _interopRequireDefault(require("@mui/material/List"));
var _Fade = _interopRequireDefault(require("@mui/material/Fade"));
var _react = _interopRequireWildcard(require("react"));
var _Popper = _interopRequireDefault(require("@mui/material/Popper"));
var _mui = require("tss-react/mui");
var _Collapse = _interopRequireDefault(require("@mui/material/Collapse"));
var _ListItem = _interopRequireDefault(require("@mui/material/ListItem"));
var _reactI18next = require("react-i18next");
var _reactCircleFlags = require("react-circle-flags");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _ListItemText = _interopRequireDefault(require("@mui/material/ListItemText"));
var _ListItemIcon = _interopRequireDefault(require("@mui/material/ListItemIcon"));
var _ListItemButton = _interopRequireDefault(require("@mui/material/ListItemButton"));
var _InputAdornment = _interopRequireDefault(require("@mui/material/InputAdornment"));
var _SwipeableDrawer = _interopRequireDefault(require("@mui/material/SwipeableDrawer"));
var _ArrowDropUp = _interopRequireDefault(require("@mui/icons-material/ArrowDropUp"));
var _ArrowDropDown = _interopRequireDefault(require("@mui/icons-material/ArrowDropDown"));
var _languageFlags = require("../helpers/languageFlags");
var _useResponsive2 = _interopRequireDefault(require("../hooks/useResponsive"));
var _Input = _interopRequireDefault(require("../Input"));
var _excluded = ["languages", "value", "showLanguageCode", "handleChange", "error", "label", "placeholder", "disabled", "multiline", "enforceDefault", "id", "name"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyles = (0, _mui.makeStyles)()(function (theme) {
  return {
    paper: {
      marginTop: theme.spacing(2),
      borderRadius: 5,
      boxShadow: theme.customShadows["default"],
      padding: theme.spacing(1, 2),
      backgroundColor: theme.palette.common.white
    },
    input: {
      margin: theme.spacing(1, 0)
    },
    multilineFlag: {
      '&.MuiInputAdornment-positionEnd': {
        position: 'relative',
        bottom: theme.spacing(2)
      }
    },
    box: {
      boxShadow: theme.customShadows["default"],
      backgroundColor: theme.palette.common.white,
      borderRadius: 5
    },
    popperTextContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      color: theme.palette.darkGrey.light
    },
    upperText: {
      textTransform: 'uppercase'
    },
    defaultLanguage: {
      fontWeight: 'bold',
      color: theme.palette.primary.main
    },
    defaultLangLabel: {
      fontSize: 10,
      marginTop: theme.spacing(-0.4)
    },
    listItemIcon: {
      minWidth: 30
    },
    containerFlag: {
      display: 'flex',
      alignItems: 'center',
      minWidth: 40,
      marginRight: theme.spacing(-0.5),
      justifyContent: 'space-between',
      textTransform: 'uppercase',
      padding: theme.spacing(0.2, 0.5),
      borderRadius: 5
    },
    mainFlagHover: {
      '&:hover': {
        backgroundColor: theme.palette.lightGrey.main,
        cursor: 'pointer'
      }
    },
    flagClicked: {
      backgroundColor: theme.palette.lightGrey.main
    },
    flagPoint: {
      position: 'absolute',
      top: theme.spacing(0),
      right: theme.spacing(0.2),
      width: theme.spacing(1.5),
      height: theme.spacing(1.5),
      borderRadius: '50%',
      border: "2px solid ".concat(theme.palette.common.white),
      backgroundColor: theme.palette.secondary.light
    },
    multilineFlagPoint: {
      position: 'relative',
      top: theme.spacing(-0.7),
      right: theme.spacing(1.1),
      width: theme.spacing(1.5),
      height: theme.spacing(1.5),
      borderRadius: '50%',
      border: "2px solid ".concat(theme.palette.common.white),
      backgroundColor: theme.palette.secondary.light
    },
    blankField: {
      backgroundColor: theme.palette.yellow.main
    },
    countryCode: {
      minWidth: 20
    },
    arrowIcon: {
      marginLeft: theme.spacing(-0.5)
    }
  };
});

// needed due to bug in babel-eslint
var concatStrings = function concatStrings(id, lang) {
  return "".concat(id, "-").concat(lang);
};
var MultilanguageInput = function MultilanguageInput(_ref) {
  var languages = _ref.languages,
    value = _ref.value,
    showLanguageCode = _ref.showLanguageCode,
    handleChange = _ref.handleChange,
    error = _ref.error,
    label = _ref.label,
    placeholder = _ref.placeholder,
    disabled = _ref.disabled,
    multiline = _ref.multiline,
    enforceDefault = _ref.enforceDefault,
    id = _ref.id,
    name = _ref.name,
    other = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles(),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    anchorEl = _useState4[0],
    setAnchorEl = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    openPopper = _useState6[0],
    setOpenPopper = _useState6[1];
  var _useTranslation = (0, _reactI18next.useTranslation)('multilanguageInputs'),
    t = _useTranslation.t;
  var _useResponsive = (0, _useResponsive2["default"])(),
    isDesktop = _useResponsive.isDesktop;
  var _ref2 = languages || {},
    defaultLanguage = _ref2["default"],
    availableLanguages = _ref2.available;
  var hasSeveralLanguages = availableLanguages.length > 1;
  var _useState7 = (0, _react.useState)((0, _languageFlags.getLanguageFlag)(defaultLanguage)),
    _useState8 = _slicedToArray(_useState7, 2),
    multilineLanguage = _useState8[0],
    setMultilineLanguage = _useState8[1];
  var handleClick = function handleClick(e) {
    if (disabled) return;
    if (multiline) {
      setOpenPopper(function (prev) {
        return !prev;
      });
      setAnchorEl(e.currentTarget);
    } else setOpen(function (prev) {
      return !prev;
    });
  };
  var handleChangeLanguage = function handleChangeLanguage(lang) {
    var newLang = (0, _languageFlags.getLanguageFlag)(lang);
    setMultilineLanguage(newLang);
    setOpenPopper(function (prev) {
      return !prev;
    });
  };
  var handleChangeValues = function handleChangeValues(fieldValue, lang) {
    handleChange(_objectSpread(_objectSpread({}, value), {}, _defineProperty({}, (0, _languageFlags.getValueAccordingToLanguage)(lang), fieldValue)));
  };
  var handleError = function handleError() {
    if (disabled) return '';
    if (!value[defaultLanguage] && !enforceDefault) return t('languageError');
    return error;
  };
  var handleToggle = function handleToggle(e) {
    if (e) e.stopPropagation();
    setOpenPopper(function (prevState) {
      return !prevState;
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({
    value: value[(0, _languageFlags.getValueAccordingToLanguage)(multilineLanguage)],
    handleChange: function handleChange(fieldValue) {
      return handleChangeValues(fieldValue, multilineLanguage);
    },
    error: handleError(),
    placeholder: placeholder,
    disabled: disabled,
    multiline: multiline,
    name: name,
    id: id,
    label: label
  }, other, {
    endAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
      position: "end",
      onClick: handleClick,
      className: cx(multiline && classes.multilineFlag)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(classes.containerFlag, hasSeveralLanguages && !disabled && classes.mainFlagHover, hasSeveralLanguages && (open || openPopper) && classes.flagClicked)
    }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      size: "small",
      disableRipple: true
    }, /*#__PURE__*/_react["default"].createElement(_reactCircleFlags.CircleFlag, {
      height: 20,
      countryCode: multilineLanguage
    }), !disabled && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(classes.flagPoint, !open && !openPopper && Object.values(value).some(function (lang) {
        return !lang;
      }) && classes.blankField, (open || openPopper) && !value[(0, _languageFlags.getValueAccordingToLanguage)(multilineLanguage)] && classes.blankField)
    })), showLanguageCode && /*#__PURE__*/_react["default"].createElement(_Typography["default"], null, (0, _languageFlags.countryToLocale)(multilineLanguage)), hasSeveralLanguages && !disabled && (open || openPopper ? /*#__PURE__*/_react["default"].createElement(_ArrowDropUp["default"], {
      className: classes.arrowIcon
    }) : /*#__PURE__*/_react["default"].createElement(_ArrowDropDown["default"], {
      className: classes.arrowIcon
    }))))
  })), /*#__PURE__*/_react["default"].createElement(_Collapse["default"], {
    "in": open && !multiline && hasSeveralLanguages
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.paper
  }, availableLanguages === null || availableLanguages === void 0 ? void 0 : availableLanguages.filter(function (lang) {
    return lang !== defaultLanguage;
  }).map(function (lang) {
    return /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({
      value: value[(0, _languageFlags.getValueAccordingToLanguage)(lang)],
      handleChange: function handleChange(fieldValue) {
        return handleChangeValues(fieldValue, lang);
      },
      className: classes.input,
      placeholder: placeholder,
      key: lang,
      id: concatStrings(id, lang),
      name: concatStrings(name, lang)
    }, other, {
      endAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
        position: "end"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.containerFlag
      }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
        size: "small",
        disableRipple: true
      }, /*#__PURE__*/_react["default"].createElement(_reactCircleFlags.CircleFlag, {
        height: 20,
        countryCode: (0, _languageFlags.getLanguageFlag)(lang)
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx["default"])(classes.flagPoint, !value[(0, _languageFlags.getValueAccordingToLanguage)(lang)] && classes.blankField)
      })), showLanguageCode && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: classes.countryCode
      }, lang)))
    }));
  }))), /*#__PURE__*/_react["default"].createElement(_Popper["default"], {
    id: "language-options",
    open: openPopper && isDesktop && hasSeveralLanguages,
    anchorEl: anchorEl,
    placement: "bottom-end",
    transition: true,
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 25]
      }
    }]
  }, function (_ref3) {
    var TransitionProps = _ref3.TransitionProps;
    return /*#__PURE__*/_react["default"].createElement(_Fade["default"], _extends({}, TransitionProps, {
      timeout: 350
    }), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
      className: classes.box
    }, /*#__PURE__*/_react["default"].createElement(_List["default"], null, availableLanguages.map(function (lang) {
      return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
        key: lang,
        disablePadding: true
      }, /*#__PURE__*/_react["default"].createElement(_ListItemButton["default"], {
        onClick: function onClick() {
          return handleChangeLanguage(lang);
        }
      }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], {
        className: classes.listItemIcon
      }, /*#__PURE__*/_react["default"].createElement(_reactCircleFlags.CircleFlag, {
        height: 20,
        countryCode: (0, _languageFlags.getLanguageFlag)(lang)
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx["default"])(classes.multilineFlagPoint, !value[(0, _languageFlags.getValueAccordingToLanguage)(lang)] && classes.blankField)
      })), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.popperTextContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx["default"])(lang === defaultLanguage && classes.defaultLanguage, classes.upperText)
      }, lang), lang === defaultLanguage && /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.defaultLangLabel
      }, t('defaultLanguage'))))));
    }))));
  }), /*#__PURE__*/_react["default"].createElement(_SwipeableDrawer["default"], {
    anchor: "bottom",
    open: openPopper && !isDesktop && hasSeveralLanguages,
    onClose: handleToggle,
    onOpen: handleToggle,
    disableSwipeToOpen: true,
    minFlingVelocity: 250
  }, /*#__PURE__*/_react["default"].createElement(_List["default"], null, availableLanguages.map(function (lang) {
    return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
      key: lang,
      disablePadding: true
    }, /*#__PURE__*/_react["default"].createElement(_ListItemButton["default"], {
      onClick: function onClick() {
        return handleChangeLanguage(lang);
      }
    }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], {
      className: classes.listItemIcon
    }, /*#__PURE__*/_react["default"].createElement(_reactCircleFlags.CircleFlag, {
      height: 20,
      countryCode: (0, _languageFlags.getLanguageFlag)(lang)
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(classes.multilineFlagPoint, !value[(0, _languageFlags.getValueAccordingToLanguage)(lang)] && classes.blankField)
    })), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.popperTextContainer
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(lang === defaultLanguage && classes.defaultLanguage)
    }, t("languages.".concat(lang))), lang === defaultLanguage && /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.defaultLangLabel
    }, t('defaultLanguage'))))));
  }))));
};
MultilanguageInput.propTypes = {
  id: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string,
  error: _propTypes["default"].string,
  label: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  multiline: _propTypes["default"].bool,
  showLanguageCode: _propTypes["default"].bool,
  handleChange: _propTypes["default"].func.isRequired,
  placeholder: _propTypes["default"].string,
  value: _propTypes["default"].shape(_defineProperty({}, _propTypes["default"].string, _propTypes["default"].string)),
  enforceDefault: _propTypes["default"].bool,
  languages: _propTypes["default"].shape({
    "default": _propTypes["default"].string,
    availableLanguages: _propTypes["default"].arrayOf(_propTypes["default"].string)
  }).isRequired
};
MultilanguageInput.defaultProps = {
  error: '',
  value: {},
  label: '',
  name: undefined,
  disabled: false,
  placeholder: '',
  multiline: false,
  enforceDefault: true,
  showLanguageCode: false
};
var _default = MultilanguageInput;
exports["default"] = _default;